import { render, staticRenderFns } from "./billAccount.vue?vue&type=template&id=632da290&scoped=true"
import script from "./billAccount.vue?vue&type=script&lang=js"
export * from "./billAccount.vue?vue&type=script&lang=js"
import style0 from "./billAccount.vue?vue&type=style&index=0&id=632da290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632da290",
  null
  
)

export default component.exports